import { useQuery, QueryResult } from '@apollo/client'
import { CompanySettingsTargetsQuery, CompanySettingsTargetsQueryVariables, Country } from '../../types'
import { COMPANY_SETTINGS_TARGETS } from './CompanySettingsQueries'

export const useCompanySettingsTargetsTemplates = (
  companyId: string,
  country: Country,
): QueryResult<CompanySettingsTargetsQuery, CompanySettingsTargetsQueryVariables> => {
  return useQuery<CompanySettingsTargetsQuery, CompanySettingsTargetsQueryVariables>(COMPANY_SETTINGS_TARGETS, {
    variables: { companyId, country },
  })
}
